import React from 'react';
import { useFides } from './useFides';

export const FidesPopup: React.FC = () => {
  const { maybeLoadFides } = useFides();

  React.useEffect(() => {
    maybeLoadFides();
  }, [maybeLoadFides]);

  return null;
};
